/*
 * @Description: 
 * @Author: doris_xu
 * @Date: 2024-06-27 15:19:26
 * @LastEditTime: 2025-11-28 14:06:52
 */
import React from 'react';
import img1 from '../../images/timeline/timeline01.png';
import img2 from '../../images/timeline/timeline02.png';
import img3 from '../../images/timeline/timeline03.png';
import img4 from '../../images/timeline/timeline04.png';
import img5 from '../../images/timeline/timeline05.png';
import img6 from '../../images/timeline/timeline06.png';
const timelineArray = [
  {
    title: '推广和报名阶段',
    cover: img1,
    disable: false,
    active: true,
    coverDirection: 'top',
  },
  {
    title: '<br/><br/>初赛阶段',
    cover: img2,
    // disable: true,
    active: true,
  },
  {
    title: '复赛阶段',
    cover: img3,
    coverDirection: 'top',
    active: true,
    // disable: true,
  },
  {
    title: '<br/><br/>项目对接阶段',
    cover: img4,
    active: true,
    // disable: true,
  },
  {
    title: '决赛阶段',
    cover: img5,
    active: true,
    coverDirection: 'top',
  },
  // {
  //   title: '2025年12月<br/>决赛暨颁奖典礼',
  //   cover: img6,
  //   active: true,
  // },
];

const TimeLine: React.FC = (props) => {
  return (
    <div className='timeline-steps-container'>
      {timelineArray.map((timeline) => {
        return (
          <div className={`timeline-step ${timeline.disable ? 'disable' : ''} ${timeline.active ? 'active' : ''}`}>
            <div className='step-top'>
              {timeline.coverDirection === 'top' ? <img src={timeline.cover} /> : <div dangerouslySetInnerHTML={{ __html: timeline.title }} />}
            </div>
            <div className={`step-middle ${timeline.coverDirection} `}>
              <div className='step-upLine'></div>
              <div className='step-dot'></div>
              <div className='step-downLine'></div>
            </div>
            <div className='step-bottom'>
              {timeline.coverDirection !== 'top' ? <img src={timeline.cover} /> : <div dangerouslySetInnerHTML={{ __html: timeline.title }} />}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TimeLine;
